var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 17.91C23.0202 18.66 22.8202 19.37 22.4602 19.98C22.2602 20.34 21.9902 20.6701 21.6902 20.9401C21.0002 21.5801 20.0902 21.9701 19.0802 22.0001C17.6202 22.0301 16.3302 21.2801 15.6202 20.1301C15.2402 19.5401 15.0102 18.8301 15.0002 18.0801C14.9702 16.8201 15.5302 15.6801 16.4302 14.9301C17.1102 14.3701 17.9702 14.0201 18.9102 14.0001C21.1202 13.9501 22.9502 15.7 23.0002 17.91Z",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 18.03L18.4504 18.99L20.5404 16.97",
    stroke: "#EE2A7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 7.43994L11.9999 12.5499L20.7699 7.46991",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.6099V12.5399",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6096 9.17V14.83C21.6096 14.88 21.6096 14.92 21.5996 14.97C20.8996 14.36 19.9996 14 18.9996 14C18.0596 14 17.1896 14.33 16.4996 14.88C15.5796 15.61 14.9996 16.74 14.9996 18C14.9996 18.75 15.2096 19.46 15.5796 20.06C15.6696 20.22 15.7796 20.37 15.8996 20.51L14.0696 21.52C12.9296 22.16 11.0696 22.16 9.92963 21.52L4.58963 18.56C3.37963 17.89 2.38965 16.21 2.38965 14.83V9.17C2.38965 7.79 3.37963 6.11002 4.58963 5.44002L9.92963 2.48C11.0696 1.84 12.9296 1.84 14.0696 2.48L19.4096 5.44002C20.6196 6.11002 21.6096 7.79 21.6096 9.17Z",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTick);
export default __webpack_public_path__ + "static/media/box-tick.6adf60cd.svg";
export { ForwardRef as ReactComponent };